module.exports = __webpack_public_path__ + "static/img/pferde.edb14c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cranio-auswahl/pferde.jpg
// module id = EEyF
// module chunks = 0